module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.total) ? _c('div', {
    staticClass: "ui-pagination"
  }, [_c('span', {
    staticClass: "total"
  }, [_vm._v("共"), _c('em', [_vm._v(_vm._s(_vm.total))]), _vm._v("条")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageCount > 1),
      expression: "pageCount > 1"
    }],
    staticClass: "pages",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.go($event)
      }
    }
  }, [_c('a', {
    staticClass: "ui-page",
    class: {
      disabled: _vm.pn == 0
    },
    attrs: {
      "href": "#",
      "data-page": _vm.pn - 1
    }
  }, [_vm._v("上一页")]), _c('a', {
    staticClass: "ui-page",
    class: {
      current: _vm.pn == 0
    },
    attrs: {
      "href": "#",
      "data-page": "0"
    }
  }, [_vm._v("1")]), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.spanRange[0] > 1),
      expression: "spanRange[0] > 1"
    }],
    staticClass: "ui-page ellipsis"
  }, [_vm._v("⋯")]), _vm._l((_vm.spanRange), function(n) {
    return _c('a', {
      staticClass: "ui-page",
      class: {
        current: n == _vm.pn
      },
      attrs: {
        "href": "#",
        "data-page": n
      }
    }, [_vm._v(_vm._s(n + 1))])
  }), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEndEllipse),
      expression: "showEndEllipse"
    }],
    staticClass: "ui-page ellipsis"
  }, [_vm._v("⋯")]), _c('a', {
    staticClass: "ui-page",
    class: {
      current: _vm.pn == _vm.pageCount - 1
    },
    attrs: {
      "href": "#",
      "data-page": _vm.pageCount - 1
    }
  }, [_vm._v(_vm._s(_vm.pageCount))]), _c('a', {
    staticClass: "ui-page",
    class: {
      disabled: _vm.pn == _vm.pageCount - 1
    },
    attrs: {
      "href": "#",
      "data-page": _vm.pn + 1
    }
  }, [_vm._v("下一页")])], 2)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9ab67ed0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9ab67ed0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/pagination.vue
// module id = 784
// module chunks = 0